import { get } from "lodash";
import { getFormSyncErrors, getFormValues } from "redux-form";
import { createSelector } from "reselect";

import {
  ADDRESS_BOOK_FORM,
  AddressBookEntity,
  AddressBookImportFields,
  BOOK_IMPORT_FORM,
  BOOK_SEARCH_FORM,
  ImportOptionsValue,
} from "~/constants/forms";
import { GB } from "~/constants/strings";
import { AddressBookSelectors } from "~/redux/orm";
import { ReferenceDataSelectors } from "~/redux/reference";
import { UmsSelectors } from "~/redux/ums";

import * as model from "./models";

export const getAddressBookValues = createSelector(
  getFormValues(ADDRESS_BOOK_FORM),
  values => values
);

export const getAddressbookType = createSelector(
  getAddressBookValues,
  address => get(address, "addressType")
);

export const getCountries = createSelector(
  ReferenceDataSelectors.getCountries,
  model.mapCountriesToKeyValue
);

export const isUserReadonlyPermissions = createSelector(
  UmsSelectors.getPreferences,
  preferences =>
    !!get(
      preferences,
      "advancedCustomerConfiguration.readOnlyAddressBook",
      false
    )
);

export const getData = state => state.ui.addressBook;

export const getAddressBooks = AddressBookSelectors.getAddressBooks;

export const getAddressBooksTotalResults = createSelector(
  getData,
  ({ totalResults }) => totalResults
);

export const getImportAddressBooksErrors = createSelector(
  getData,
  ({ importErrors }) => importErrors
);

export const getTemplateValue = createSelector(
  getFormValues(BOOK_IMPORT_FORM),
  values => values[AddressBookImportFields.TEMPLATE]
);

export const getImportOptionValue = createSelector(
  getFormValues(BOOK_IMPORT_FORM),
  values => values[AddressBookImportFields.IMPORT_OPTIONS]
);

export const groupImportBehaviorIsDisabled = createSelector(
  getFormValues(BOOK_IMPORT_FORM),
  (values = {}) => {
    if (
      values[AddressBookImportFields.IMPORT_OPTIONS] ===
        ImportOptionsValue.IMPORT_NEW_ONLY ||
      values[AddressBookImportFields.IMPORT_OPTIONS] ===
        ImportOptionsValue.EMPTY
    ) {
      return true;
    }

    if (
      values[AddressBookImportFields.IMPORT_OPTIONS] ===
        ImportOptionsValue.OVERWRITE &&
      values[AddressBookImportFields.TEMPLATE] === "1"
    ) {
      return true;
    }
  }
);

export const getAddressType = createSelector(getAddressBookValues, values =>
  get(values, "addressType", "")
);

export const getCountryCode = createSelector(getAddressBookValues, values =>
  get(values, "address.countryCode", "")
);

export const getSelectedCountry = createSelector(
  getCountryCode,
  getCountries,
  model.getCountryByCountryCode
);

export const getRequiredFields = createSelector(
  getAddressBookValues,
  values => {
    const countryCode = get(values, "address.countryCode", null);

    return {
      [AddressBookEntity.SHORT_NAME]: true,
      [AddressBookEntity.ADDRESS.POSTCODE]: countryCode === GB,
      [AddressBookEntity.ADDRESS.COUNTRY_CODE]: true,
      [AddressBookEntity.ADDRESS.STREET]: true,
      [AddressBookEntity.ADDRESS.TOWN]: true,
      [AddressBookEntity.ADDRESS_TYPE]: true,
    };
  }
);

export const getSearchFormErrors = createSelector(
  getFormSyncErrors(BOOK_SEARCH_FORM),
  errors => errors
);
